var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[_c('v-select',{staticClass:"v-select-user bg-white",attrs:{"name":_vm.name,"clearable":false,"label":"text","options":_vm.options,"placeholder":_vm.placeholder},on:{"input":function (event) {
	var _obj;

	return _vm.$emit('filtered', ( _obj = {}, _obj[_vm.filterType] = event ? event.value : event, _obj ));
}}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6b692f47","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/UserPanel/Elements/TableSelectField.vue
// module id = null
// module chunks = 